export default __webpack_public_path__ + "static/media/decrement.54c57519.svg";